<!-- Desktop menu -->
<terra-lp-desktop-nav *ngIf="!isMobileScreenSize && isMainNavbarVisible$ | async"></terra-lp-desktop-nav>

  <!-- Page content -->
  <section class="page-content">
    <terra-lp-top-notification *ngIf="isMainNavbarVisible$ | async"></terra-lp-top-notification>
    <router-outlet></router-outlet>
  </section>

<!-- Mobile menu -->
<terra-lp-mobile-nav *ngIf="isMobileScreenSize && isMainNavbarVisible$ | async"></terra-lp-mobile-nav>
